<div *ngIf="cmsPage && cmsPage.childCmsPages.length > 0" class="card card-shadow">
    <div class="card-header bg-default text-white fw-bold">
        {{ cmsPage.title }}
    </div>
    <div class="card-body p-0">
        <ul class="list-group list-group-flush">
            <li *ngFor="let item of cmsPage.childCmsPages" class="list-group-item">
                <a class="text-dark" [routerLink]="['/page/' + item.slug]">
                    {{item.title}}
                </a>
            </li>
        </ul>
    </div>
</div>
<div *ngIf="cmsPage && cmsPage.childCmsPages.length <= 0 && cmsPage.parentCmsPage" class="card card-shadow">
    <div class="card-header bg-default text-white fw-bold">
        {{ cmsPage?.parentCmsPage?.title }}
    </div>
    <div class="card-body p-0">
        <ul class="list-group list-group-flush">
            <li *ngFor="let item of cmsPage?.parentCmsPage?.childCmsPages" class="list-group-item">
                <a class="text-dark" [routerLink]="['/page/' + item.slug]">
                    {{item.title}}
                </a>
            </li>
        </ul>
    </div>
</div>